export const ourServices = [
    {
        id: 1,
        title: 'Design',
        text: 'Our company specializes in providing comprehensive design services tailored to businesses. We offer expert design solutions encompassing custom theme development, responsive design implementation, and visually engaging layouts to ensure exceptional user experiences for your online store visitors.',
        homeText: 'We will help you set up your Shopify store from scratch, including configuring your store settings, adding products, and setting up payment gateways.',
    },
    {
        id: 2,
        title: 'Development',
        text: 'We offer a wide range of services including custom theme development, seamless integration of apps and plugins, and efficient e-commerce solutions. We are committed to building high-performance, scalable, and secure websites that empower your business to thrive in the digital marketplace.',
        homeText: 'We will help you set up your Shopify store from scratch, including configuring your store settings, adding products, and setting up payment gateways.',
    },
    {
        id: 3,
        title: 'Optimization',
        text: 'We employ industry best practices to optimize your online store for improved performance, faster loading times and enhanced user experience. From optimizing code and images to implementing caching mechanisms, we ensure your website operates at its full potential, driving growth and maximizing customer satisfaction.',
        homeText: 'We will help you set up your Shopify store from scratch, including configuring your store settings, adding products, and setting up payment gateways.',
    },
    {
        id: 4,
        title: 'Maintenance',
        text: 'From regular backups and security updates to troubleshooting and bug fixes, our dedicated team ensures that your website remains secure, up-to-date, and free from technical glitches. With our maintenance services, you can focus on your core business while we take care of the ongoing upkeep and performance optimization.',
        homeText: 'We will help you set up your Shopify store from scratch, including configuring your store settings, adding products, and setting up payment gateways.',
    },
    {
        id: 5,
        title: 'Consulting',
        text: 'We offer strategic guidance and tailored solutions to help you make informed decisions throughout your e-commerce journey. Whether it\'s selecting the right apps, optimizing your product catalog, or formulating effective marketing strategies, our consulting services empower you to  achieve your business goals.',
        homeText: 'We will help you set up your Shopify store from scratch, including configuring your store settings, adding products, and setting up payment gateways.',
    },
    {
        id: 6,
        title: 'Migration to shopify',
        text: 'Whether you are transitioning from another e-commerce platform or upgrading from an older version, we ensure a smooth transfer of your products, customer data, order history, and other crucial elements, ensuring minimal disruption and a hassle-free transition to the robust features and flexibility of the Shopify platform.',
        homeText: 'We will help you set up your Shopify store from scratch, including configuring your store settings, adding products, and setting up payment gateways.',
    }
];

export const ourServicesEmpower = [
    {
        id: 1,
        title: 'Expertise & Specialization',
        text: 'Our team has in-depth knowledge and expertise. providing users high-quality, tailored solutions that align with their business objectives.'
    },
    {
        id: 2,
        title: 'Enhanced Online Presence',
        text: 'We offer customized designs, optimized functionality, and user-friendly interfaces which attract more visitors,  and increase their brand credibility.'
    },
    {
        id: 3,
        title: 'Time & Resource Efficiency',
        text: 'By outsourcing the website creation to us, users can save valuable time and resources, allowing them to focus on core business activities.'
    },
    {
        id: 4,
        title: 'Ongoing Support & Growth',
        text: 'We provide ongoing support and opportunities for growth. Additionally, we provide strategic guidance, consulting, and continuous optimization.'
    }
]

export const testimonials = [
    {
        id: 1,
        message: "Working with them has been a game-changer for our business. Their expertise in ecommerce development and attention to detail helped us create a stunning online store that exceeded our expectations. Highly recommended!",
        author: 'John, CEO of XYZ Clothing Co'
    },
    {
        id: 2,
        message: `I am extremely impressed with the level of service and expertise offered by [Company Name]. They transformed our outdated website into a modern and user-friendly platform. The team was responsive, attentive, and delivered outstanding results. I couldn't be happier!" - `,
        author: 'Emily, Director of GHI Cosmetics.'
    },
    {
        id: 3,
        message: `"From the initial consultation to the final launch, [Company Name] exceeded our expectations. Their deep understanding of ecommerce trends, coupled with their creative approach, resulted in a website that truly represents our brand. We highly recommend their services!`,
        author: 'Mark, Co-Founder of JKL Sports Gear.'
    },
]

export const processSteps = [
    {
        id: 1,
        text: 'Consultation',
    },
    {
        id: 2,
        text: 'Planning & Strategy',
    },
    {
        id: 3,
        text: 'Content Creation',
    },
    {
        id: 4,
        text: 'Custom Design & Development',
    },
    {
        id: 5,
        text: 'E-commerce Functionality',
    },
    {
        id: 6,
        text: 'Launch & Optimization',
    },
    {
        id: 7,
        text: 'Ongoing Support & Maintenance',
    }
];

export const industriesBenefits = [
    {
        id: 1,
        title: 'Fashion-Focused Expertise',
        text: 'We have an in-depth understanding of fashion trends, user behavior, and industry best practices.',
    },
    {
        id: 2,
        title: 'Effective Content Strategy',
        text: 'We have an in-depth understanding of fashion trends, user behavior, and industry best practices.',
    },
    {
        id: 3,
        title: 'Tailored Solutions',
        text: "We tailor our Shopify solutions to align perfectly with your fashion brand's vision, ensuring your online store is as unique as your products.",
    },
    {
        id: 4,
        title: 'Advanced SEO',
        text: "We implement robust SEO strategies to boost your website's visibility in search engines, helping you reach a wider audience and increase organic traffic.",
    },
    {
        id: 5,
        title: 'Integration Expertise',
        text: "Whether it's integrating with payment gateways, inventory management systems, or third-party apps, we have the technical prowess to make your fashion website function seamlessly.",
    },
    {
        id: 6,
        title: 'Ongoing Support',
        text: "We provide ongoing maintenance, updates, and support to keep your online fashion store running smoothly.",
    }
];

export const industriesAbout = [
    {
        id: 1,
        text: "Discover the ease and convenience of Shopify storefronts, where you can create your dream online store without any hassle. With a user-friendly interface and a wide range of customizable templates, you'll have everything you need to begin selling your products in no time.",
    },
    {
        id: 2,
        text: "Enjoy the convenience of deploying your store globally with a single click, utilizing Shopify's robust infrastructure for top-notch uptime and security.",
    },
    {
        id: 3,
        text: "Deliver exceptional shopping experiences to your customers with lightning-fast storefronts, powered by a performance-optimized framework and modern developer tools.",
    },
    {
        id: 4,
        text: "Access dedicated technical support to ensure a smooth launch and continuous optimization for your Shopify storefront.",
    },
    {
        id: 5,
        text: "Enjoy the convenience of deploying your store globally with a single click, utilizing Shopify's robust infrastructure for top-notch uptime and security.",
    }
];

export const industriesQuestions = [
    {
        id: 1,
        question: 'How can Shopify benefit my fashion brand?',
        answer: 'We implement responsive design principles to ensure your Shopify store looks and works great on mobile devices. This is essential as a significant portion of fashion shoppers use smartphones for online shopping',
    },
    {
        id: 2,
        question: 'How do you ensure my fashion store is mobile-friendly',
        answer: 'We implement responsive design principles to ensure your Shopify store looks and works great on mobile devices. This is essential as a significant portion of fashion shoppers use smartphones for online shopping',
    },
    {
        id: 3,
        question: 'Can you help with fashion-focused SEO strategies',
        answer: 'We implement responsive design principles to ensure your Shopify store looks and works great on mobile devices. This is essential as a significant portion of fashion shoppers use smartphones for online shopping',
    },
];

export const ourWorksFilters = [
    {
        id: 1,
        text: 'All',
        category: 'all',
    },
    {
        id: 2,
        text: 'Fashion',
        category: 'fashion',
    },
    {
        id: 3,
        text: 'Sport',
        category: 'sport'
    },
    {
        id: 4,
        text: 'Home & Decor',
        category: 'home',
    },
    {
        id: 5,
        text: 'Beauty and Cosmetics',
        category: 'beauty'
    },
    {
        id: 6,
        text: 'Food and Beverages',
        category: 'food',
    },
    {
        id: 7,
        text: 'Pet Supplies',
        category: 'pet_supplies'
    }
];

export const ourWorksItems = [
    {
        id: 1,
        title: 'Sport accessories',
        description: 'Conceptualized, designed, and released in 5 weeks. Used by over 200,000 users worldwide.',
        category: 'sport',
    },
    {
        id: 2,
        title: 'Home Decor Boutique',
        description: 'Conceptualized, designed, and released in 5 weeks. Used by over 200,000 users worldwide.',
        category: 'home',
    },
    {
        id: 3,
        title: 'Coffee shop for experts',
        description: 'Conceptualized, designed, and released in 5 weeks. Used by over 200,000 users worldwide.',
        category: 'food',
    },
    {
        id: 4,
        title: 'Organic and Health Food Store',
        description: 'Conceptualized, designed, and released in 5 weeks. Used by over 200,000 users worldwide.',
        category: 'fashion'
    },
    {
        id: 5,
        title: 'Beauty and Skincare Products Store',
        description: 'Conceptualized, designed, and released in 5 weeks. Used by over 200,000 users worldwide.',
        category: 'beauty',
    },
    {
        id: 6,
        title: 'Pet Supplies and Accessories Shop',
        description: 'Conceptualized, designed, and released in 5 weeks. Used by over 200,000 users worldwide.',
        category: 'pet_supplies',
    },
];

export const discoverBrands = [
    {
        id: 1,
        title: 'User-Friendly Interface',
        description: 'Shopify is known for its user-friendly interface, making it easy for brands to set up and manage their online stores without extensive technical knowledge.'
    },
    {
        id: 2,
        title: 'App Ecosystem',
        description: 'Shopify boasts a vast app ecosystem by integrating various apps for inventory management, marketing automation, analytics, customer support, and more.'
    },
    {
        id: 3,
        title: 'Security and Reliability',
        description: 'Brands trust Shopify for its robust security measures and reliable hosting services. Shopify handles security updates, data backups, and infrastructure maintenance.'
    },
    {
        id: 4,
        title: 'API and Customization',
        description: 'The API allows brands to access and manipulate their store\'s data programmatically, enabling seamless integration with external systems, like ERP software, CRM systems etc.'
    }
];

export const strorefrontsList = [
    {
        id: 1,
        text: 'Get your online business up and running effortlessly with Shopify storefronts. Benefit from a fully functional and ready-to-go demo store, complete with reference code, to kickstart your journey.',
    },
    {
        id: 2,
        text: "Enjoy the convenience of deploying your store globally with a single click, utilizing Shopify's robust infrastructure for top-notch uptime and security.",
    },
    {
        id: 3,
        text: 'Deliver exceptional shopping experiences to your customers with lightning-fast storefronts, powered by a performance-optimized framework and modern developer tools.',
    },
    {
        id: 4,
        text: 'Access dedicated technical support to ensure a smooth launch and continuous optimization for your Shopify storefront.',
    }
];

export const individualConditions = [
    {
        id: 1,
        text: 'Customized Store Design: We created a visually appealing and user-friendly website design tailored to the organic and health food niche.',
    },
    {
        id: 2,
        text: 'E-commerce Functionality: We implemented robust e-commerce features on Shopify, ensuring seamless transactions and secure payment processing for customers.',
    },
    {
        id: 3,
        text: 'Product Listings and Descriptions: We optimized product listings with high-quality images, and detailed information about each organic and health food item.',
    },
    {
        id: 4,
        text: 'SEO and Digital Marketing: We employed SEO strategies and digital marketing techniques to enhance the website\'s visibility in search engines.',
    }
]